import { computed, observable, set, action } from 'mobx';
import { IInStoreServiceAPI } from '../../../api/Interfaces';

export interface IInStoreService {
    id: number;
    serviceCategoryId: number;
    serviceCategoryName: string;
    name: string;
    price: number;
    onlineContentId: string;
    totalDuration: string;
    imageUrl: string;
    description: string;
    isVirtual: boolean;
}

export class InStoreService implements IInStoreService {
    @observable public id: number;
    @observable public serviceCategoryId: number;
    @observable public serviceCategoryName: string;
    @observable public name: string;
    @observable public price: number;
    @observable public onlineContentId: string;
    @observable public totalDuration: string;
    @observable public imageUrl: string;
    @observable public description: string;
    @observable public isVirtual: boolean;
    @observable public totalDurationWithPadding: string;
    @observable public virtual: boolean;

    @computed
    public get isFree() {
        return this.price === 0;
    }

    public static fromJSON(data: IInStoreServiceAPI) {
        const item = new InStoreService();

        item.id = Number(data.id);
        item.name = data.name;
        item.price = Number(data.price);
        item.onlineContentId = data.onlineContentId;
        item.totalDuration = data.totalDuration;
        item.isVirtual = Boolean(Number(data.virtual));
        item.serviceCategoryName = data.category.name;

        return item;
    }

    @action
    public update(updates: Partial<IInStoreService>) {
        set(this, updates);
    }
}
